export enum ReservationPermissions {
  ALL = "Travel:Reservations:*",
  READ = "Travel:Reservations:Read",
  WRITE = "Travel:Reservations:Write",
  CANCEL = "Travel:Reservations:Cancel",
  REFUND = "Travel:Reservations:Refund",
}

export function hasReservationAccess(userPermissions: string[]): boolean {
  return userPermissions.some((p) =>
    [ReservationPermissions.READ, ReservationPermissions.ALL, "*"].includes(p)
  );
}
